import styled from 'styled-components';

export const SelectorWrapper = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: 400;
  color: var(--text-color);
  letter-spacing: -0.8px;
`;

export const RadioInput = styled.input`
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;

  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: var(--primary-color);
  }
`;

export const ErrorMessage = styled.span`
  font-family: 'Montserrat', sans-serif;
  color: #F89393;
  font-size: 12px;
  margin-top: 4px;
`;
